/** Shared building blocks (components/kit): page header, filter bar, bulk bar, side panel, states, density, toasts. */
export const kit = {
  more: "More",
  advanced: "Advanced",
  technicalDetails: "Technical details",
  filters: "Filters",
  clearFilters: "Clear filters",
  activeFilters: "Active filters",
  removeFilter: "Remove filter: {{label}}",
  search: "Search",
  selected_one: "{{count}} selected",
  selected_other: "{{count}} selected",
  clearSelection: "Clear selection",
  bulkActions: "Actions for the selected items",
  noMatches: "Nothing matches these filters",
  noMatchesHint: "Try other filters, or clear them to see everything.",
  loading: "Loading…",
  openFullPage: "Open full page",
  close: "Close",
  undo: "Undo",
  undone: "Undone",
  undoFailed: "Couldn't undo this. Try again.",
  density: {
    label: "Density",
    comfortable: "Comfortable",
    compact: "Compact",
  },
};
